import { render } from "./batch-stats.vue?vue&type=template&id=73ea2e1c&lang=pug"
import script from "./batch-stats.vue?vue&type=script&lang=js"
export * from "./batch-stats.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__